import React from 'react'
import { Layout, Menu, Button, message, Icon, Modal, Row, Radio, Col  } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import * as actionCreators from '../service/ClientLinkCreator'
import { connect } from 'react-redux'
import './Header.css'
import AddModal from '../components/AddCaModal'
import intl from 'react-intl-universal';
const { Sider } = Layout;
const confirm = Modal.confirm;
class LeftSide extends React.Component {
  constructor() {
    super()
    this.getChannelsBycategoryid = this.getChannelsBycategoryid.bind(this)
    this.addOnlick = this.addOnlick.bind(this)
  }

  componentDidMount() {
    this.props.initAdultControl(sessionStorage.getItem("userName"));
    this.props.initCategoryList(sessionStorage.getItem("userName"));
  }

  getChannelsBycategoryid(id, name) {
    this.props.getChannelsBycategoryid(this.props.pageSize, id, sessionStorage.getItem("userName"), name)
  }

  addOnlick = (e) => {
    e.preventDefault();
    let action = e.target.name
    if (action === "modify" && this.props.categoryList.length === 0) {
      message.error("there was none category")
    } else {
      this.props.showAddModal(action)
    }
  }

  deleteOnlick = (categoryid) => {
    var that = this
    confirm({
      title: "Are you sure to delete this category",
      onOk() {
        that.props.deleteCategory(categoryid, sessionStorage.getItem("userName"), that.props.pageSize)
      }
    });
  }

  onChangeAdultControl = (e) =>{
    let value = e.target.value
    var that = this
    confirm({
      title: (value === 1 ? "Do you want to turn off adult channel ?" : "Do you want to turn on adult channels ?"),
      onOk() {
        that.props.adultControl(sessionStorage.getItem("userName"), value)
      }
    });
  }


  render() {
    const buttonStyle = {
      marginLeft: -3,
      marginRight: 8,
      float: "left"
    }
    const menuItemDiv = {
      marginLeft: "30px"
    }
    const siderStyle = {
      overflowY: "scroll",
      width: this.props.clientWidth * 0.18,
      height: this.props.clientHeight,
    }
    const channelTextStyle = {
      fontWeight: "bold",
      fontSize: 16
    }
    
    return (
      <Sider width={300} trigger={null} style={siderStyle}>
        <div className="logo" id="logo">
          <Link to="/">
            <h1 className="projectName">My Link</h1>
          </Link>
        </div>

        {/* 屏蔽成人节目 */}
        {
           sessionStorage.getItem('ifshowSnAdult') === 'false' ?
            <Row>
              <Col span={14}>
                <label style={{ fontWeight: "bold", fontSize: 24, color: "white" }}>{intl.get("adult.control")}</label>
              </Col>
              <Col span={10}>
                <Radio.Group value={this.props.adultControlValue} buttonStyle="solid" onChange={(e) => this.onChangeAdultControl(e)}>
                  <Radio.Button value={1}>OFF</Radio.Button>
                  <Radio.Button value={0}>ON</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            : ""
        }
        <div className="clear"></div>
        <div style={{ backgroundColor: "#001529", height: 100, padding: 15 }}>
          <Button type="primary" name="add" style={buttonStyle} onClick={(e) => this.addOnlick(e)}>{intl.get("add")}</Button>
          <Button type="primary" name="modify" style={buttonStyle} onClick={(e) => this.addOnlick(e)}>{intl.get("modify")}</Button>
          <Button type="primary" style={buttonStyle} onClick={() => this.deleteOnlick(this.props.selectKey)}>{intl.get("delete")}</Button>
          <div className="clear" />
          <span style={{ fontWeight: "bold", fontSize: 24, color: "white", float: "left" }}>{intl.get("category")}</span>
        </div>
        <Menu
          mode="inline"
          theme="dark"
          style={{
            width: '100%',
          }}
          onClick={this.onSubClick}
          selectedKeys={[this.props.selectKey]}
        >
          {
            this.props.categoryList.map((item) => {
              return <Menu.Item key={item.id} onClick={() => this.getChannelsBycategoryid(item.id, item.name)}>
                <div style={menuItemDiv}>
                  <Icon type="folder"></Icon>
                  <span style={channelTextStyle}>{item.name}</span>
                </div>
              </Menu.Item>
            })
          }
        </Menu>
        <AddModal />
      </Sider>
    );
  }
}
const mapState = (state) => {
  return {
    categoryList: state.clientLink.categoryList,
    pageSize: state.clientLink.pageSize,
    clientWidth: state.clientLink.clientWidth,
    clientHeight: state.clientLink.clientHeight,
    categoryid: state.clientLink.categoryid,
    selectKey: state.clientLink.selectKey,
    adultControlValue : state.clientLink.adultControlValue,
  }
}
const mapDispatch = (dispatch) => {
  return {
    initCategoryList(userName) {
      dispatch(actionCreators.initCategoryList(userName))
    },

    getChannelsBycategoryid(pageSize, id, userName, name) {
      dispatch(actionCreators.updateCurrentPage(1))
      dispatch(actionCreators.getChannelListByPage(1, pageSize, id, userName, name))
      dispatch(actionCreators.updataSelectKey(id))
    },

    showAddModal(action) {
      dispatch(actionCreators.showAddModal(action))
    },

    deleteCategory(categoryid, userName, pageSize) {
      dispatch(actionCreators.deleteCategory(categoryid, userName, pageSize))
    },

    adultControl(user, flag){
      dispatch(actionCreators.adultControl(user, flag))
    },
    initAdultControl(user){
      dispatch(actionCreators.initAdultControl(user))
    }
  }
}

export default connect(mapState, mapDispatch)(withRouter(LeftSide));


// WEBPACK FOOTER //
// ./src/layouts/LeftSide.js